export default () => {
  return {
    'section-headline': {
      letterSpacing: '0.8px',
    },
  } as const
}
